import { Fragenkatalog } from "@/models/FragenkatalogModels"

export type State = {
  fragenkatalog: Array<Fragenkatalog>
}

export const state: State = {
  fragenkatalog: sessionStorage.getItem("fragenkatalog") != null ? JSON.parse(sessionStorage.fragenkatalog) : new Array<Fragenkatalog>(),
}
